import React from "react";

function LetsBuild() {
    return (
        <div className="container p-5">
            <div
                className="pricing-style-one-item-cos bg-dark text-light"
                style={{
                    backgroundImage:
                        "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
                }}
            >
                <div className="text-center">
                    <h3>Let’s Build the Future Together
                    </h3>
                    <div className="bottom">
                        <div className="pricing">
                            <p>
                                Explore the vast potential of decentralized technologies with Xeer Technology. Our Web3 development services are designed to align with your business goals, helping you create innovative, secure, and efficient solutions that resonate with today’s digital-first consumers!
                            </p>
                        </div>
                        <a className="btn btn-style-one mt-30" href="#">
                            Get Started
                        </a>
                    </div>
                </div>
                {/* <div className="right-info"></div> */}
            </div>
        </div>
    );
}

export default LetsBuild;